<template>
	<div class="product" v-if="product" :class="{ selected, compact }">
		<!-- <div class="d-flex align-items-center justify-content-between px-3 mt-3">
			<div class="logo"><img src="~@/assets/logo-grey.png" /></div>
			<div class="uid">{{ product.code }}</div>
		</div> -->
		<img :src="product.image" class="img-fluid" />
		<div class="info">
			<div class="title">{{ product.name }}</div>

			<h2>
				{{ product.points }}
				<span class="label">PUNTOS</span>
			</h2>
		</div>
		<div class="p-2">
			<div class="btn btn-primary btn-block" v-ripple @click="$emit('clicked', product)">{{ btnText }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Product',
	props: {
		product: {
			type: Object,
			required: true,
		},
		btnText: {
			type: String,
		},
		selected: {
			type: Boolean,
			default: false,
		},
		compact: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style scoped>
.product {
	background-color: #ffffff;
	border: solid 1px rgb(228, 228, 228);
	border-radius: 8px;
	overflow: hidden;
}
.product.selected {
	border: solid 1px #a50034;
}
.product .logo img {
	width: 64px;
}
.product .uid {
	font-weight: 600;
}
.product .info {
	padding: 8px 16px;
	text-align: center;
}
.product .info .title {
	font-weight: 500;
	font-size: 14pt;
}
.product .info .label {
	color: #999;
}
.product .info h2 {
	font-weight: 600;
}

.product.compact .info .title {
	font-size: 10pt;
}
.product.compact .info h2 {
	font-size: 14pt;
}
</style>
